import { createRoute } from '@tanstack/react-router';
import { ZakazniciList } from '@/modules/zakaznici/ZakazniciList';
import { Route as RootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/zakaznici',
  component: ZakazniciList,
});
